
import Vue from "vue";
import { namespace } from "vuex-class";
import { Component, Prop, PropSync, Ref } from "vue-property-decorator";
import Vuetify from "vuetify";
import util from "util";
import UserService from "@/services/UserService";

const Notifications = namespace("Notifications");

@Component({})
export default class AlteracaoSenhaComponent extends Vue {
  private isFormValida = false;
  private isLoading = false;
  private senhas = {
    nova: "",
    novaVerif: "",
  };
  private pwdBtn = {
    reg: false,
    regVerif: false,
  };

  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;

  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  private regras = {
    vazio: (v: string) => {
      return !!v || "Campo obrigatório";
    },
    minChars: (v: string) => {
      return (v && v.length >= 8) || "Mínimo de 8 caracteres";
    },
    passwordMatch: (v: string) => {
      return (v && v === this.senhas.nova) || "Senhas não coincidem";
    },
  };

  voltar(evento: any) {
    if (!evento) return;
    this.$emit("onVoltarPrincipal");
  }

  mounted() {
    this.isLoading = false;
  }

  efetuarRecSenha() {
    if (this.isFormValida) {
      const locStorUsr = localStorage.getItem("changeUser");
      const usr = locStorUsr ? JSON.parse(locStorUsr) : null;

      const newPwd = {
        userId: usr.userId,
        newPassword: this.senhas.nova,
        pwdToken: usr.pwdToken,
      };
      this.isLoading = true;
      UserService.passwordRecoverySetNewPassword(newPwd)
        .then(
          (response) => {
            this.showInfoMessage("Alteração de senha efetuada com sucesso!");
            this.voltar({});
          },
          (error) => {
            const message = error.response.data || error.message || error;
            this.showErrorMessage(message);
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  onFechar() {
    this.$emit("fecharDialog");
  }
}
